import { useEffect, useState } from "react";
import { fetchTop, type TopOpportunity } from "./api";
import { DISCLAIMER, flagPhrase } from "./copy";

// Monday digest preview — what the email blast will look like.
// The actual email send is server-side (next phase). This is the on-site preview
// + a copyable HTML/text body so you can drop it into your sender of choice.

const DIGEST_SIZE = 10;

export function MondayEmail() {
  const [items, setItems] = useState<TopOpportunity[] | null>(null);
  useEffect(() => { fetchTop(DIGEST_SIZE).then(setItems).catch(()=>setItems([])); }, []);

  if (!items) return <div className="ps-digest"><p>Loading…</p></div>;
  const today = new Date().toISOString().slice(0,10);

  return (
    <div className="ps-digest">
      <header className="ps-digest__head">
        <div className="ps-digest__brand">ParcelSignal</div>
        <div className="ps-digest__sub">Monday digest · {today} · Miami-Dade unincorporated</div>
      </header>

      <p className="ps-digest__intro">
        Top {DIGEST_SIZE} parcels by upzone potential this week. Each is{" "}
        <em>{flagPhrase("flag")}</em> — confirm with counsel before any offer.
      </p>

      <ol className="ps-digest__list">
        {items.map((it) => (
          <li key={it.parcel.folio} className="ps-digest__row">
            <div className="ps-digest__topline">
              <span className="ps-digest__rank">#{it.rank}</span>
              <span className="ps-digest__score">{Math.round(it.parcel.opportunityScore ?? 0)}</span>
              <span className="ps-digest__folio">{it.parcel.folio}</span>
            </div>
            <div className="ps-digest__meta">
              {it.parcel.address ?? "—"} · Δ {it.parcel.upzoneDelta?.toFixed(1) ?? "—"} u/ac
            </div>
            <div className="ps-digest__stale">
              Data as of {it.parcel.asOfDate} · Rules: {it.parcel.rulesetVersion}
            </div>
          </li>
        ))}
      </ol>

      <p className="ps-digest__disclaimer" role="note">{DISCLAIMER}</p>

      <p className="ps-digest__foot">
        <a href="/">← back to map</a>
      </p>
    </div>
  );
}
